import React, { useCallback, useState, useEffect } from 'react';
import Globali18n from 'i18n-js';
import { translations } from 'assets/translations';
Globali18n.translations = translations;
Globali18n.defaultLocale = 'en';
export const LocaleContext = React.createContext({
    I18n: Globali18n,
    // tslint:disable-next-line:no-empty
    changeLocale: (_) => { },
    // tslint:disable-next-line:no-empty
    translation: (scope, options) => { },
});
const convertMarkUpToHTML = (text) => {
    const markUpValues = ['bold', 'white', 'green', 'yellow', 'blue'];
    const spanCloseRegex = new RegExp('\\[/.*?\\]', 'gm');
    let convertedText = text.replace(spanCloseRegex, '</span>');
    markUpValues.map((value) => {
        const regex = new RegExp(`\\[${value}\\]`, 'gm');
        convertedText = convertedText.replace(regex, `<span class="${value}">`);
    });
    return convertedText;
};
const LocaleProvider = ({ children }) => {
    // spread global value to change ref and force update
    const [I18n, setLocale] = useState({ ...Globali18n });
    const changeLocale = useCallback((loc) => {
        // @ts-ignore
        const translation = translations[loc];
        Globali18n.translations = { [loc]: translation };
        Globali18n.locale = loc;
        // spread global value to change ref and force update
        setLocale({ ...Globali18n });
    }, []);
    const translation = useCallback((scope, options) => {
        const i18 = I18n.t(scope, { ...options, interpolation: { escapeValue: false } });
        const text = convertMarkUpToHTML(i18);
        if (!text) {
            return `${scope} not found`;
        }
        return React.createElement("span", { dangerouslySetInnerHTML: { __html: text } });
    }, [I18n]);
    useEffect(() => {
        // set default locale
        changeLocale('nl');
    }, [changeLocale]);
    useEffect(() => {
        Globali18n.defaultLocale = 'nl';
    }, []);
    return (React.createElement(LocaleContext.Provider, { value: {
            I18n,
            changeLocale,
            // @ts-ignore
            translation,
        } }, children));
};
export default LocaleProvider;
